.cBoth.no_float {
  float: none;
  clear: both;
}

.main {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.sub {
  flex-grow: 1;
  margin: 0 12.5rem;
}

.main {
  height: auto;
}

.a_button {
  text-decoration: none;
  display: inline-block;
  font-size: var(--text-lg);
  background-color: var(--primary-color-100);
  color: var(--secondary-color-gray100);
  font-weight: 600;
  display: flex;
  justify-content: center;
}

.main .a_button {
  padding: 12px 124px;
  border-radius: 9999px;
}

.section {
  margin: 0 -12.5rem;
  padding: 5rem 12.5rem;
  justify-content: center;
  align-items: center;
  height: auto;
  background-color: white;
}

.section_left {
  justify-content: flex-start;
}

.section_left * {
  float: left;
}

.section_right {
  justify-content: flex-end;
}

.section_right * {
  float: right;
}

.section_right .description * {
  text-align: right;
}

.section h3 {
  color: var(--primary-color-100);
  font-size: var(--text-2lg);
  font-weight: 700;
}

.section_sec_top {
  display: flex;
  height: 420px;
  padding: 5rem 0 0;
  background-color: transparent;
  /* background-image: url("/images/Img_home_top.png"); */
  background-repeat: no-repeat;
  background-position: bottom 0 right 8rem;
}

.section_sec_bottom_divider {
  padding: 4rem;
  margin: 0 -12.5rem;
  background-color: var(--secondary-color-gray100);
}

.section_sec_bottom {
  display: flex;
  height: 540px;
  padding: 143px 0 0;
  background-color: transparent;
  /* background-image: url("/images/Img_home_bottom.png"); */
  background-repeat: no-repeat;
  background-position: bottom 0 right 8rem;
}

.section h2 {
  font-size: var(--text-4xl);
}

.section_sec_bottom h2 {
  padding: var(--text-4xl);
}

.description {
  height: 444px;
  padding: var(--text-4xl);
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--text-sm);
  background-color: var(--secondary-color-gray50);
}

.section_sec_top .description,
.section_sec_bottom .description {
  background-color: transparent;
  margin-right: -3em;
}

.img_home_top {
  max-width: 100%;
  width: 746px;
  height: 340px;
}

.img_home_middle {
  width: 588px;
  height: 444px;
  background-color: var(--secondary-color-gray100);
}

.img_home_bottom {
  max-width: 100%;
  width: 746px;
  height: 397px;
}

@media (max-width:1200px) {

	.main .a_button {
		padding: 12px 80px;
	}

	.section_sec_top,
	.section_sec_bottom {
		height: unset;
	}

	.img_home_top,
	.img_home_bottom {
		width: unset;
	}

	.img_home_middle {
		height: auto;
	}

	.section_sec_top .description,
	.section_sec_bottom .description,
	.section_sec_bottom h2 {
		height: unset;
		padding: var(--text-4xl) 0;
	}

	.sub {
		margin: 0 auto;
	}

	.section {
		flex-direction: column;
		margin: 0 auto;
		padding: 0 24px;
	}

	.section_sec_bottom_divider {
		margin: 0;
	}

	.main {
		padding: 15px;
	}
}

@media (max-width:744px) {

	.main .a_button {
		padding: 12px;
		max-width: 75%;
	}

	.sub {
		margin: 0 auto;
	}

	.section {
		margin: 0 auto;
		padding: 0 16px;
	}

	.section_sec_top,
	.section_sec_bottom {
		background-position: bottom 0 center;
	}

	.main {
		padding: 10px;
	}
}
